import { render, staticRenderFns } from "./BaoCunZiChanFuZhai.vue?vue&type=template&id=6da14e4c&scoped=true"
import script from "./BaoCunZiChanFuZhai.vue?vue&type=script&lang=js"
export * from "./BaoCunZiChanFuZhai.vue?vue&type=script&lang=js"
import style0 from "./BaoCunZiChanFuZhai.vue?vue&type=style&index=0&id=6da14e4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da14e4c",
  null
  
)

export default component.exports